import React, { Component, PropTypes } from 'react';
import { Colors } from 'Css';

const css = oxygenCss({
  root: {
    textAlign: 'center'
  },
  image: {
    maxWidth: '100%'
  },
  caption: {
    fontStyle: 'italic',
    color: Colors.text.Dark.disabled
  }
});

class StoreImageModule extends Component {
  static propTypes = {
    src: PropTypes.string,
    caption: PropTypes.string
  };

  render() {
    const { src, caption } = this.props;
    return (
      <div className={css.root}>
        <img className={css.image} src={src} />
        <figcaption className={css.caption}>{caption}</figcaption>
      </div>
    );
  }
}

export default StoreImageModule;



// WEBPACK FOOTER //
// ./src/js/components/Store/Modules/StoreImageModule.js